import { render } from "./finance-user.vue?vue&type=template&id=4b3ca2cd"
import script from "./finance-user.vue?vue&type=script&lang=js"
export * from "./finance-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__